export const SENTIMENT_COLOR: Record<string, string> = {
  positive: "#34d399",
  neutral: "#94a3b8",
  concerned: "#fbbf24",
  frustrated: "#fb923c",
  overwhelmed: "#f87171",
};

export const BU_ACCENT: Record<string, string> = {
  locate2u: "#67e8f9",
  zoom2u: "#fb923c",
  shred2u: "#a78bfa",
  manila: "#f472b6",
  group: "#94a3b8",
};

export function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10);
}

export function nextMondayIso(now: Date = new Date()): string {
  const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const day = d.getUTCDay(); // 0..6 Sun..Sat
  const diff = day === 1 ? 7 : (8 - day) % 7 || 7;
  d.setUTCDate(d.getUTCDate() + diff);
  return d.toISOString().slice(0, 10);
}

export function thisMondayIso(now: Date = new Date()): string {
  const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const day = d.getUTCDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setUTCDate(d.getUTCDate() + diff);
  return d.toISOString().slice(0, 10);
}
